import React from 'react';
import { CustomIcon } from 'modules/components/layer00';
import { SaveReportAttachmentForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';
import { useTheme } from '@mui/material';

export type SaveReportAttachmentModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveReportAttachmentModalProps) => {
  const params = useParams();
  const theme = useTheme();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save Attachment'
      subTitle='Upload your attachment'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      headerIcon={(
        <CustomIcon.large.FC
          icon='FILE'
          stroke={theme.palette.primary.main}
        />
      )}
    >

      <SaveReportAttachmentForm.FC
        id={props.id}
        clientReportId={params.clientReportId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
